module.exports = __webpack_public_path__ + "img/background-fl-detail.ad12f706.svg";